<template>
    <div>
        <v-card>
            <v-card-title>
                Machship Error Actions
                <v-btn
                    class="ml-auto"
                    icon
                    @click="tips = !tips">
                    <v-icon dark>
                        mdi-information
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="p-0">
                <v-alert
                    :value="tips"
                    outlined
                    color="primary"
                    dark
                    border="right"
                    transition="scale-transition">
                    <div class="title">
                        Tips
                    </div>
                    <p v-for="(tip, index) in errorTips"
                        :key="'tips-' + index">
                        {{ tip }}
                    </p>
                </v-alert>

                <div v-if="integrationId">
                    <v-progress-linear
                        v-if="isLoading"
                        indeterminate
                        color="primary"
                        class="mb-5">
                    </v-progress-linear>

                    <v-form
                        ref="form"
                        @submit="onSubmit">
                        <v-list>
                            <v-list-item v-for="(err, index) in errors" :key="'err-' + index">
                                <v-list-item-content>
                                    {{ err.desc }}
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-radio-group v-model="err.option" row>
                                        <v-radio
                                            v-for="(action, ii) in actions"
                                            :key="'act-' + ii + '-' + index"
                                            :label="action | toActionLabel"
                                            :value="action">
                                        </v-radio>
                                    </v-radio-group>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>

                        <div class="d-flex p-3">
                            <v-spacer></v-spacer>
                            <v-btn small type="submit" color="primary">Save</v-btn>
                        </div>
                    </v-form>

                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import { capitalize } from '@/js/pipes/index.js';

export default {
    props: {
        id: { type: Number, default: null },
    },

    filters: {
        toActionLabel: (value) => {
            value = value == 'pending_email' ? 'Pending Email' : value
            return capitalize(value)
        }
    },

    computed: {
        integrationId() {
            return this.id
        }
    },

    mounted() {

        // get all errors first
        let params = { integration_id: this.id }
        this.$http
            .get('/api/machship/error-actions', { params })
            .then(({ data  }) => {
                console.log("[MACHSHIP_ERROR_ACTIONS][GET] error list", data)

                if (data.errors) {
                    let saved = data.saved_actions ? JSON.parse(data.saved_actions.meta_value) : null

                    this.errors = data.errors.map(error => {

                        let ierror = { desc: error, option: 'email' }

                        // we only map saved actions if exist
                        if (saved) {
                            let index = saved.findIndex(act => error == act.desc)
                            if (index >= 0) {
                                ierror.option = saved[index].option
                            }
                        }

                        return ierror
                    })

                }

                // this will be use action choices
                this.actions = data.actions

            })

    },

    data() {
        return {
            valid: false,
            isLoading: false,
            actions: [],
            errors: [],
            tips: false,
            errorTips: [
                'Email - this will email the client if an error occur when syncing to machship',
                'Pending - This will set the record as pending and retry sycing again',
                'Pending and Email - This will do both above.',
                'None - No action will be taken when an error occurs'
            ]
        }
    },

    methods: {
        async onSubmit(e) {
            e.preventDefault();

            // stops spam
            if (this.isLoading) {
                return;
            }

            try {

                this.isLoading = true

                let result = this.$http.post('/api/machship/error-actions', {
                    integration_id: this.id,
                    actions: JSON.stringify(this.errors)
                })

                console.log("[MACHSHIP_ERROR_ACTIONS][SAVE]", result)
                EventBus.$emit('show-success', 'Successfully saved machship error actions.');

                this.isLoading = false
            } catch (err) {
                EventBus.$emit('show-err', err);

                this.isLoading = false
            }
        }
    }
}
</script>
